var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-header__topbar"},[_c('search-dialog'),(_vm.isCurrentUserSuperAdmin)?_c('user-switcher-dialog'):_vm._e(),_c('top-notification'),_c('top-user')],1)}
var staticRenderFns = []

export { render, staticRenderFns }